import type { Novidade } from './tipos';

/** Fase 2, W16 (novidade na W17): funcionário com um vínculo por empresa do grupo e a folha calculada por vínculo. */
export const novidadeVinculos: Novidade = {
  id: '2026-10-05-vinculos',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: 'pessoas',
  permissao: 'pessoas.ver',
  rota: '/pessoas/pessoas/funcionarios',
  textos: {
    pt: {
      titulo: 'Funcionário com vínculo por empresa e folha por vínculo',
      resumo: 'A mesma pessoa pode trabalhar em mais de uma empresa do grupo: um cadastro e um vínculo em cada empresa.',
      passos: [
        'Na ficha do funcionário, o cartão Vínculos mostra um vínculo por empresa, com admissão, função, salário e situação.',
        'Ao admitir alguém com CPF já cadastrado no grupo, o aviso oferece Acrescentar vínculo nesta empresa, sem cadastro repetido.',
        'Encerrar um vínculo desliga só naquela empresa; o cadastro e os outros vínculos continuam.',
        'A folha de cada empresa calcula sobre os vínculos dela na competência. Confira os vínculos antes de recalcular.',
      ],
    },
    en: {
      titulo: 'Employee with a link per company and payroll per link',
      resumo: 'The same person can work in more than one group company: one record and one employment link in each company.',
      passos: [
        'On the employee record, the Employment links card shows one link per company, with hire date, role, salary and status.',
        'When hiring someone whose CPF is already in the group, the notice offers Add link in this company, with no repeated record.',
        'Ending a link terminates only in that company; the record and the other links stay.',
        'The payroll of each company is calculated on its own links in the period. Check the links before recalculating.',
      ],
    },
    es: {
      titulo: 'Empleado con vínculo por empresa y nómina por vínculo',
      resumo: 'La misma persona puede trabajar en más de una empresa del grupo: un registro y un vínculo en cada empresa.',
      passos: [
        'En la ficha del empleado, la tarjeta Vínculos muestra un vínculo por empresa, con ingreso, puesto, salario y situación.',
        'Al contratar a alguien con CPF ya registrado en el grupo, el aviso ofrece Agregar vínculo en esta empresa, sin registro repetido.',
        'Cerrar un vínculo da de baja solo en esa empresa; el registro y los otros vínculos siguen.',
        'La nómina de cada empresa se calcula sobre sus vínculos en el período. Revisa los vínculos antes de recalcular.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-vinculos/vinculos.webp', null, null, null],
  treinamento: { curso: 'novidades' },
};
